module.exports = __webpack_public_path__ + "img/peoImg3.a861e124.png";